// extracted by mini-css-extract-plugin
module.exports = {"hero":"SimpleHero-module--hero--phxBI","heroHeadline":"SimpleHero-module--heroHeadline--1yG6U"};